import GetOrganisationRequestModelBase from '../_generated/modelBases/get-organisation-request-model-base';

export default class GetOrganisationRequestModel extends GetOrganisationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
